import { useSelector } from "react-redux";

export const useAccount = accountId => {
  const { clientData } = useSelector((state) => state.Client);
  const { openAccounts } = clientData;

  return openAccounts.filter(
    (account) => account.accountNumber === accountId
  )[0];
};